var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#d6c17a",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.98438,6.96875c-0.53125,0.01563 -1.03125,0.23438 -1.39844,0.61719l-18.58594,18.58594l-18.58594,-18.58594c-0.37891,-0.38672 -0.89453,-0.60547 -1.4375,-0.60547c-0.8125,0 -1.54297,0.49609 -1.84766,1.25c-0.30859,0.75391 -0.125,1.61719 0.45703,2.18359l21.41406,21.41406l21.41406,-21.41406c0.59375,-0.57031 0.78125,-1.44922 0.46094,-2.21094c-0.31641,-0.76172 -1.06641,-1.25 -1.89062,-1.23437zM44.98438,19.96875c-0.53125,0.01563 -1.03125,0.23438 -1.39844,0.61719l-18.58594,18.58594l-18.58594,-18.58594c-0.37891,-0.38672 -0.89453,-0.60547 -1.4375,-0.60547c-0.8125,0 -1.54297,0.49609 -1.84766,1.25c-0.30859,0.75391 -0.125,1.61719 0.45703,2.18359l21.41406,21.41406l21.41406,-21.41406c0.59375,-0.57031 0.78125,-1.44922 0.46094,-2.21094c-0.31641,-0.76172 -1.06641,-1.25 -1.89062,-1.23437z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDd);
export default __webpack_public_path__ + "static/media/dd.8d70d9c101b35fc866dbe9e397d3c09a.svg";
export { ForwardRef as ReactComponent };